// 项目名字
export const websitname = "kissmevv";
// 页面默认title
export const defaultTitle = "kissmevv";
// 网站地址
export const websiteurl = "https://www.ilove11.top";
// Email
export const email = "kissmevv@outlook.com";
// 账户名称
export const account = "kissmevv";
// PC 和移动端在所有环境中统一使用此图片域名
export const imgurl = "https://www.ilove11.top";

// 聊天默认使用当前站点的 /wss/；独立聊天域名通过构建环境变量配置。
export const webSocketUrl =
  (process.env.VUE_APP_WEBSOCKET_URL || "").trim() ||
  (process.env.NODE_ENV === "development"
    ? "ws://127.0.0.1:6679"
    : `${window.location.protocol === "https:" ? "wss:" : "ws:"}//${window.location.host}/wss/`);


